export default __webpack_public_path__ + "../staticImages/sprite-dhl-2x.png";